import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { faListAlt } from '@fortawesome/pro-regular-svg-icons';
import { Store } from '@ngxs/store';
import { AuthState } from '@wilson/auth/core';
import { ShiftTemplate } from '@wilson/interfaces';
import { ShiftTimelinePreferredSettingsState } from '@wilson/preferred-settings/state';
import {
  CreateNewViaDragAndDropService,
  DragAndDropModeService,
} from '@wilson/shift-timeline/services';
import { AddShiftTemplateToSuggestionList } from '@wilson/shift-timeline/state';
import { filter, Observable, switchMap } from 'rxjs';
import { ShiftTemplateHelperService } from '../shift-template-drop-zone/shift-template-helper.service';

@Component({
  selector: 'wilson-quick-creation-bar',
  templateUrl: './quick-creation-bar.component.html',
  styleUrls: ['./quick-creation-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class QuickCreationBarComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly dragAndDropModeService = inject(DragAndDropModeService);
  readonly createNewViaDragAndDropService = inject(
    CreateNewViaDragAndDropService,
  );
  private readonly shiftTemplateHelperService = inject(
    ShiftTemplateHelperService,
  );

  @Input() isQuickCreationCardOpen = true;
  public faListAlt = faListAlt;
  public selectedShiftTemplate = null;
  public isShiftTemplateDropDownOpen = false;
  protected nzMinWidthConfig = { 'min-width': '250px' };
  protected isCellView$!: Observable<boolean>;

  ngOnInit(): void {
    this.isCellView$ = this.store.select(AuthState.userId).pipe(
      filter((userId) => !!userId),
      switchMap((userId) =>
        this.store.select(
          ShiftTimelinePreferredSettingsState.isCellView(userId as string),
        ),
      ),
    );
  }

  selectTemplate(shiftTemplate: ShiftTemplate | null): void {
    this.store.dispatch(new AddShiftTemplateToSuggestionList(shiftTemplate));
    setTimeout(() => {
      this.selectedShiftTemplate = null;
      this.cdRef.detectChanges();
    });
  }

  startDrag(shiftTemplate: ShiftTemplate): void {
    setTimeout(() => {
      this.isShiftTemplateDropDownOpen = false;
      this.cdRef.detectChanges();
    });
    this.shiftTemplateHelperService.setShiftTemplate(shiftTemplate);
    this.createNewViaDragAndDropService.setShiftTemplateDropZone(true);
    this.dragAndDropModeService.setDraggingItemId(
      CreateNewViaDragAndDropService.MOCK_SHIFT_ID,
    );
  }

  dragEnd(): void {
    this.createNewViaDragAndDropService.setShiftTemplateDropZone(false);
    this.dragAndDropModeService.setDraggingItemId(null);
  }
}
